var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.links),function(link){return _c('li',[_c('small',[(link.url)?_c('a',{attrs:{"target":"_blank","href":_vm.baseurl + link.url}},[_vm._v(_vm._s(link.title))]):_vm._e(),_vm._v(" "),(!link.url)?_c('span',[_vm._v(_vm._s(link.title))]):_vm._e()])])}))}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aa05d66","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Modules/CityPlan/Resources/assets/js/components/SectionLinks.vue
// module id = hNKX
// module chunks = 0